import React from 'react';
import { withTranslation, WithTranslation } from 'react-i18next';
import { withRouter } from 'react-router-dom';
import { PapiUser } from '@wix/da-types-papi';
import Button, {
  ProfileOwnerWatchButton,
} from '@wix/da-shared-react/pkg/Button';
import WatchButtonConneсtContainer from '../WatchButton.container';
import Sticky from '@wix/da-shared-react/pkg/Sticky';
import SubNavBarMobileInner from './SubNavBarMobileInner';
import ErrorBoundary from '@wix/da-shared-react/pkg/ErrorBoundary';
import {
  withVerification,
  WithVerificationProps,
} from '@wix/da-shared-react/pkg/VerificationPopup/withVerification';
import { Route as RouteDefinition } from '../../../../types/route';
import { Url } from '@wix/da-url';

import cssVars from '@wix/da-shared-react/src/styles/variables.scss';
import s from './SubNavBarMobile.scss';

export interface SubNavBarProps {
  routes: RouteDefinition[];
  profileOwnerUser: PapiUser;
  isOwner: boolean;
  biClickProfileNavBar: (linkName: string) => void;
}
const WatchButtonMobile = WatchButtonConneсtContainer(ProfileOwnerWatchButton);

class SubNavBarMobile extends React.Component<
  SubNavBarProps & WithTranslation & WithVerificationProps
> {
  render() {
    const {
      isOwner,
      routes,
      t,
      isVerificationNeeded,
      pushVerificationPopup,
      biClickProfileNavBar,
    } = this.props;

    // T42244: The sticky header gets stuck a pixel too low sometimes
    const stickyHeight = parseInt(cssVars['site-header-height-mobile']) - 1;

    return (
      <div className={s['root']}>
        <ErrorBoundary>
          {!isOwner && (
            <div className={s['action-buttons']}>
              <a
                href={
                  isVerificationNeeded
                    ? undefined
                    : Url.userNoteLink(this.props.profileOwnerUser.username)
                }
                onClick={
                  isVerificationNeeded
                    ? () => pushVerificationPopup('notes')
                    : undefined
                }
                className={s['message-btn']}
              >
                <Button view="b2" fullWidth={false}>
                  {t!(`common.message`)}
                </Button>
              </a>
              <WatchButtonMobile className={s['watch-btn']} />
            </div>
          )}
          <div className={s['sticky-placeholder']}>
            <Sticky
              zIndex={parseInt(s['z-index'])}
              marginTop={stickyHeight}
            >
              {isSticky => (
                <SubNavBarMobileInner
                  routes={routes}
                  isSticky={isSticky}
                  biClickProfileNavBar={biClickProfileNavBar}
                />
              )}
            </Sticky>
          </div>
        </ErrorBoundary>
      </div>
    );
  }
}

export default withRouter(withVerification(withTranslation()(SubNavBarMobile)));
